import { render, staticRenderFns } from "./price-tag.vue?vue&type=template&id=77969b5b&scoped=true"
import script from "./price-tag.vue?vue&type=script&lang=js"
export * from "./price-tag.vue?vue&type=script&lang=js"
import style0 from "./price-tag.vue?vue&type=style&index=0&id=77969b5b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77969b5b",
  null
  
)

export default component.exports